import ButtonChangeVerificationState from '../ButtonChangeVerificationState';
import type { ICertifications } from '@/lib/interface.ts';
import { Button } from '@/components/ui/button.tsx';
import type { IHasCertification } from '.';
import { cn } from '@/lib/utils';

type TProps = IHasCertification & {
	onClick?: (item: ICertifications, accept: boolean) => void;
	deniedStateChange?: boolean;
	removeItemLocally?: (userId: string) => void;
};

const UserCertificationItemFooter = ({ certification, onClick, deniedStateChange, removeItemLocally }: TProps) => (
	<div className={cn(
		'flex items-center justify-center gap-2 px-2',
		'md:gap-3'
	)}>
		<Button
			type='button'
			className={'min-w-36'}
			variant={'destructive'}
			onClick={() => onClick?.(certification, false)}>
			Refuser
		</Button>
		<Button
			type='button'
			variant={'default'}
			className={'min-w-36'}
			onClick={() => onClick?.(certification, true)}>
			Accepter
		</Button>
		{
			!deniedStateChange &&
			<ButtonChangeVerificationState verificationId={certification._id} onAction={() => removeItemLocally?.(certification.userData._id)} onError={() => window.location.reload()} />
		}
	</div>
);

export default UserCertificationItemFooter;

